import { render, staticRenderFns } from "./newsTable.vue?vue&type=template&id=0476f148&scoped=true"
import script from "./newsTable.vue?vue&type=script&lang=ts"
export * from "./newsTable.vue?vue&type=script&lang=ts"
import style0 from "./newsTable.vue?vue&type=style&index=0&id=0476f148&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0476f148",
  null
  
)

export default component.exports